import { Type } from "js-yaml";
import { CUSTOM_TAGS } from "../constants.js";
class ParsedVariable {
  variable;
  constructor(variable) {
    this.variable = variable;
  }
}
const VariableTag = new Type(CUSTOM_TAGS.VARIABLE, {
  kind: "scalar",
  resolve: (data) => data !== null && typeof data === "string",
  construct: (data) => new ParsedVariable(data),
  instanceOf: ParsedVariable,
  represent: (data) => data.variable
});
export {
  ParsedVariable,
  VariableTag
};
